import ItemCard from './ItemCard.container'

export default ItemCard
